/* eslint-disable */

import * as companyManagementService from "../../../services/company";
import * as settings from "../../../services/settings";
import * as warehouseManagementService from "../../../services/warehouse";

import { Button, Col, Form, Modal, Row, Select, Spin, notification } from "antd";
import { useCallback, useEffect, useState } from "react";

import { useAccessToken } from "../../../contexts/AccessTokenContext";
import { validateCreateRoute } from "../../validations/validateCreateRoute";

const initPage = { limit: 0, page: 1 };

export const ModalCreateRoutes = ({
  t,
  handleCancel,
  fetchCompanyRoutes,
  editCompanyRoutesData,
  companyRoutesData,
  detailData,
  isModalOpen,
  setIsModalOpen,
  isEdit,
}) => {
  const { accessToken } = useAccessToken();
  const [formRoutes] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [destination, setDestination] = useState([]);
  const [origin, setOrigin] = useState([]);
  const [api, contextHolder] = notification.useNotification();
  const [search, setSearch] = useState(initPage);
  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const onSubmitRoutes = async () => {
    const values = await formRoutes.getFieldsValue();
    const { origin, destination } = values || {};
    const prepareDataCompanyRoutes = {
      company_id: detailData.id,
      destination_id: destination,
      origin_id: origin,
      old_destination_id: editCompanyRoutesData.destination_id,
      old_origin_id: editCompanyRoutesData.origin_id,
    };
    const { isValid } = validateCreateRoute(values);
    if (isValid) {
      try {
        if (isEdit) {
          if (typeof origin === "string") {
            prepareDataCompanyRoutes.origin_id = editCompanyRoutesData.origin_id;
          }
          if (typeof destination === "string") {
            prepareDataCompanyRoutes.destination_id = editCompanyRoutesData.destination_id;
          }
          prepareDataCompanyRoutes.id = editCompanyRoutesData.id;
          prepareDataCompanyRoutes.company_id = editCompanyRoutesData.company_id;
          const responseData = await companyManagementService.updateCompanyRoutes(
            accessToken,
            prepareDataCompanyRoutes
          );
          if (responseData.status === 422) {
            openNotificationWithIcon(
              settings.NotificationType.ERROR,
              <>{"Error"}</>,
              <>{responseData.response.data.message}</>
            );
          } else {
            openNotificationWithIcon(
              settings.NotificationType.SUCCESS,
              <>{"Success."}</>,
              <>{"Update routes Success"}</>
            );
            setIsModalOpen(false);
          }
        } else {
          const responseData = await companyManagementService.createCompanyRoutes(
            accessToken,
            prepareDataCompanyRoutes
          );
          if (responseData.status === 422) {
            openNotificationWithIcon(
              settings.NotificationType.ERROR,
              <>{"Error"}</>,
              <>{responseData.response.data.message}</>
            );
          } else {
            openNotificationWithIcon(
              settings.NotificationType.SUCCESS,
              <>{"Success."}</>,
              <>{"Create routes Success"}</>
            );
            setIsModalOpen(false);
          }
        }
        fetchCompanyRoutes();
        setLoading(false);
      } catch (err) {
        const { message } = settings.getErrorMessage(err);
        openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
        console.error("[ModalCreateRoutes] onSubmitRoutes: ", err);
      }
    } else {
      openNotificationWithIcon(
        settings.NotificationType.ERROR,
        <>{"ERROR."}</>,
        <>{`Please check data is request create company routes`}</>
      );
      setLoading(false);
    }
  };

  const fetchCompanyWareHouseRoutes = useCallback(async (param) => {
    setLoading(true);
    let resDestination = [];
    let resOrigin = [];
    try {
      const data = await warehouseManagementService.getWarehouses(accessToken, param);
      if (data !== undefined) {
        data.warehouse.map((value) => {
          if (value.is_destination === true) {
            resDestination.push({
              value: value.id,
              label: value.warehouse_code,
            });
          }
          if (value.is_origin === true) {
            resOrigin.push({
              value: value.id,
              label: value.warehouse_code,
            });
          }
        });
      }
      setSearch({ ...param });
      setDestination(resDestination);
      setOrigin(resOrigin);
    } catch (err) {
      console.error("[ModalCreateRoutes] fetchCompanyWareHouseRoutes: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      setLoading(false);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    setLoading(true);
    if (accessToken) {
      const values = {
        is_active: "true",
      };

      if (isEdit) {
        const origin = editCompanyRoutesData.app_warehouse_app_companyroute_origin_idToapp_warehouse;
        if (origin) {
          formRoutes.setFieldValue(
            "origin",
            editCompanyRoutesData.app_warehouse_app_companyroute_origin_idToapp_warehouse.warehouse_code
          );
        }
        const destination = editCompanyRoutesData.app_warehouse_app_companyroute_destination_idToapp_warehouse;
        if (destination) {
          formRoutes.setFieldValue(
            "destination",
            editCompanyRoutesData.app_warehouse_app_companyroute_destination_idToapp_warehouse.warehouse_code
          );
        }
      }
      search.page = 1;
      fetchCompanyWareHouseRoutes({ ...search, values });
    }
  }, [accessToken, fetchCompanyWareHouseRoutes, formRoutes, isEdit]);

  return (
    <>
      {contextHolder}
      <Modal
        title={
          <div className="mb-4">
            {isEdit
              ? t("Company_Create.Create_Routes.Text_Edit_Routes")
              : t("Company_Create.Create_Routes.Text_Add_Routes")}
          </div>
        }
        open={isModalOpen}
        className="rounded-lg border-2"
        closable={true}
        centered={true}
        forceRender={true}
        onCancel={handleCancel}
        footer={() => (
          <>
            <Button type="primary" onClick={onSubmitRoutes}>
              {t("BTN_Save", { ns: "buttons" })}
            </Button>
            <Button onClick={handleCancel}>{t("BTN_Cancel", { ns: "buttons" })}</Button>
          </>
        )}
      >
        <Spin spinning={loading}>
          <Form form={formRoutes} labelAlign="left" labelCol={{ flex: "140px" }}>
            <Row gutter={24}>
              <Col span={24}>
                <Form.Item
                  label={t("Company_Create.Create_Routes.Table_Origin") + ":"}
                  name="origin"
                  key="origin"
                  style={{ marginBottom: "1rem" }}
                >
                  <Select
                    style={{ width: "100%" }}
                    placeholder={t("Company_Create.Create_Routes.Select_Placeholder")}
                    allowClear
                    options={origin}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label={t("Company_Create.Create_Routes.Table_Destination") + ":"}
                  name="destination"
                  key="destination"
                  style={{ marginBottom: "1rem" }}
                >
                  <Select
                    style={{ width: "100%" }}
                    placeholder={t("Company_Create.Create_Routes.Select_Placeholder")}
                    allowClear
                    options={destination}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Modal>
    </>
  );
};
